import { action, observable } from "mobx";
import ResultsService from "@services/results/ResultsService.mobile";
import {
	ResultsMenuCategory,
	ResultsMenuSport,
	ResultsMenuTournament,
} from "@data-types/results";
import type { RootStore } from "@state/stores/types";
import { ResultsDataStoreMobile } from "@state/stores/results";

export default class ResultsMenuStoreMobile {
	rootStore: RootStore;
	resultsDataStore: ResultsDataStoreMobile;

	defaultDaysFromToday = -7;

	@observable resultMenu: ResultsMenuSport[] | null;
	@observable selectedSport: ResultsMenuSport | null = null;
	@observable selectedCategory: ResultsMenuCategory | null = null;
	@observable selectedTournament: ResultsMenuTournament | null = null;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
		this.resultsDataStore = new ResultsDataStoreMobile(rootStore, this);
	}

	@action.bound
	async onInitialize() {
		const resultMenuRequest = await ResultsService.getMenu(
			this.defaultDaysFromToday
		);

		if (resultMenuRequest.success) {
			this.resultMenu = resultMenuRequest.data;
		}
	}

	@action.bound
	setSelectedTournament(tournament: ResultsMenuTournament) {
		this.selectedTournament = tournament;
	}

	@action.bound
	setSelectedCategory(category: ResultsMenuCategory) {
		this.selectedCategory = category;
	}

	@action.bound
	setSelectedSport(sport: ResultsMenuSport) {
		this.selectedSport = sport;
	}

	@action.bound
	goBack() {
		if (this.selectedTournament) {
			this.selectedTournament = null;
			this.resultsDataStore.onReset();
		} else if (this.selectedCategory) {
			this.selectedCategory = null;
			this.resultsDataStore.onReset();
		} else if (this.selectedSport) {
			this.selectedSport = null;
		} else if (this.rootStore.searchBarViewStore.persistentTerm) {
			this.rootStore.searchBarViewStore.onReset();
			this.resultsDataStore.onReset();
		}
	}
}
